<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-checkbox v-model="value.eli5" label="ELI5">
        </v-checkbox>
      </v-col>
      <v-col cols="4">
        <v-checkbox v-model="value.pdpbox" label="PDPBox">
        </v-checkbox>
      </v-col>
      <v-col cols="4">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-text-field v-model="value.name" label="Company name"
          hint="Field name of NAME field."
          persistent-hint
          class="mt-0 pt-0"
          type="text">
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="value.target" label="target"
          hint="Field name of TARGET field."
          persistent-hint
          class="mt-0 pt-0"
          type="text">
        </v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field v-model="value.drop" label="ROE,ROA,INVratio"
          hint="Comma-separated drop fields."
          persistent-hint
          class="mt-0 pt-0"
          type="text">
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
function defaults() {
  return {
    name: '',
    target: '',
    drop: '',
    eli5: true,
    pdpbox: true
  }
}
export default {
  props: {
    value: {
      type: Object,
      require: false,
      default: () => defaults()
    }
  },
  data() {
    return {}
  },
  mounted: function() {
    var d = defaults();
    Object.keys(d).forEach(k => { this.value[k] = d[k]});
    console.log(this.value)
  },
  computed: {
  },
  methods: {
  }
}
</script>
